import React from "react"
import {findDOMNode} from "react-dom"

import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover"
import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import FieldSelectFields from "../../select-fields"
import convertFieldsStructureToConfig, {
    FieldSelectorConfig
} from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure"

const debug = false
// const debug = "FieldSelectFields_Popover"

export default function FieldSelectFields_Popover(props:any) {

    const field : FieldSelectFields = props.field

    const config: FieldSelectorConfig = convertFieldsStructureToConfig(field.fieldsStructure)
    let columns          = _.map(props.value, fieldId=>({fieldId}))

    debug && console.log(debug, 'render', props.value, columns)

    const onSelect = (fieldId:ID | null) => {
        debug && console.log(debug, 'onSelect', fieldId)
        // props.parent.hidePopover()
        const newValues = props.value ? gd.utils.toggleArrayValue(props.value, fieldId) : [fieldId]

        debug && console.log(debug, 'onSelect newValues', newValues)

        props.parent.onValueChange(newValues, false)
    };

    return (
        <Popover
            position        = {PopoverPosition.bottomLeft()}
            popoverClass    = "gd-popover-add-column-new h-300"
            onClickOutside  = {()=>props.parent.hidePopover()}
            getTargetFunc   = {()=>findDOMNode(props.parent)}
        >
            <PopoverAddColumn
                config              = {config}
                fields              = {field.fields.models}
                columns             = {columns}
                selectedFieldIds    = {[]}
                mandatoryColumnsIds = {[]}
                isAddVisible        = {false}
                hidePopover         = {props.parent.hidePopover}
                onToggleColumn      = {onSelect}
                onNewCustomField    = {()=>{}}
            />
        </Popover>
    )
}
